"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentPromotionBaseAllOfImagesToJSON = exports.ContentPromotionBaseAllOfImagesFromJSONTyped = exports.ContentPromotionBaseAllOfImagesFromJSON = exports.instanceOfContentPromotionBaseAllOfImages = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ContentPromotionBaseAllOfImages interface.
 */
function instanceOfContentPromotionBaseAllOfImages(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfContentPromotionBaseAllOfImages = instanceOfContentPromotionBaseAllOfImages;
function ContentPromotionBaseAllOfImagesFromJSON(json) {
    return ContentPromotionBaseAllOfImagesFromJSONTyped(json, false);
}
exports.ContentPromotionBaseAllOfImagesFromJSON = ContentPromotionBaseAllOfImagesFromJSON;
function ContentPromotionBaseAllOfImagesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'width': !(0, runtime_1.exists)(json, 'width') ? undefined : json['width'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
        'height': !(0, runtime_1.exists)(json, 'height') ? undefined : json['height'],
    };
}
exports.ContentPromotionBaseAllOfImagesFromJSONTyped = ContentPromotionBaseAllOfImagesFromJSONTyped;
function ContentPromotionBaseAllOfImagesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'width': value.width,
        'url': value.url,
        'height': value.height,
    };
}
exports.ContentPromotionBaseAllOfImagesToJSON = ContentPromotionBaseAllOfImagesToJSON;
